import { selectCurrentProjectFestival } from '@/domain/project-festival/project-festival.selectors';
import { selectCurrentProjectVenue } from '@/domain/project-venue/project-venue.selectors';
import { RootState } from '@/domain/store';

import { selectCurrentProjectTour } from '../project-tour/project-tour.selectors';

export const selectCurrentProjectMode = (state: RootState) => {
  return state.project.mode;
};

export const selectCurrentProject = (state: RootState) => {
  const projectMode = selectCurrentProjectMode(state);
  if (projectMode === 'festival') {
    return selectCurrentProjectFestival(state);
  } else if (projectMode === 'venue') {
    return selectCurrentProjectVenue(state);
  } else if (projectMode === 'tour') {
    return selectCurrentProjectTour(state);
  } else {
    throw new Error('Unhandled project mode');
  }
};

export const selectIsExportingReport = (state: RootState) => {
  return state.project.isExportingReport;
};
